import { Controller as BaseController } from 'stimulus'
import Rails from '@rails/ujs'
import { useDispatch } from 'stimulus-use'

export class Controller extends BaseController {
  static targets = ['self']

  static values = { targetId: String, itemsLoaded: Number }

  initialize() {
    useDispatch(this)
  }

  itemsLoadedValueChanged() {
    this.dispatch('itemsLoaded', this.itemsLoadedValue)
  }

  async loadMoreResults(event) {
    event.preventDefault()

    const continuationToken = event.currentTarget.getAttribute('data-continuation-token')
    const resetToken = event.currentTarget.getAttribute('data-reset-token')
    const url = event.currentTarget.getAttribute('data-url')

    const loadMoreParams = {
      continuation_token: continuationToken,
      reset_token: resetToken,
      target_id: this.selfTarget.id
    }

    Rails.ajax({
      type: 'POST', // POST instead of GET because the continuation token can be pretty long
      url: url,
      dataType: 'script',
      data: $.param(loadMoreParams)
    })
  }

  async reloadComponent(event) {
    const button = $(`#load-more-${this.selfTarget.id}`)[0].children[0].children[0]

    button.setAttribute('loading', 'true')
    button.blur()
    $(`#ul-${this.selfTarget.id}`)[0].innerText = ' '

    await this.loadMoreResults(event)
  }
}
